import { artemisService } from './artemis.service';
import { AACampaign } from '@akross/artemis-ads-sdk';
import { logger } from '../utils/logger.util';

export class ChallengeService {
  /**
   * Busca campanhas do Artemis
   * Retorna campanhas da SDK diretamente (sem enriquecimento)
   */
  async getChallenges(zoneId: string, size: number = 100): Promise<AACampaign[]> {
    try {
      const response = await artemisService.getCampaignsByZone(zoneId, size);
      return response.getCampaigns();
    } catch (error: unknown) {
      logger.error('Erro ao buscar desafios:', error);
      const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
      throw new Error(`Erro ao buscar desafios: ${errorMessage}`);
    }
  }

  /**
   * Busca detalhes de uma campanha específica
   */
  async getCampaignDetail(campaignUuid: string, zoneId: string): Promise<AACampaign | null> {
    try {
      const campaigns = await this.getChallenges(zoneId, 100);
      return campaigns.find(c => c.campaignUuid === campaignUuid) || null;
    } catch (error: unknown) {
      logger.error('Erro ao buscar detalhes da campanha:', error);
      return null;
    }
  }
}

export const challengeService = new ChallengeService();

